define('shoptheme/components/layout/search',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints
) {
	return Component.create({
		block:				null,
		formContainer:		null,
		button:				null,
		closeButton:		null,
		autoComplete:		null,
		input:				null,

		isMobile:			true,

		$init: function() {
			var self = this;
			this.block = BEM.block("search");
			this.formContainer = this.block.getElements("form-container");
			this.button = this.block.getElements("button");
			this.closeButton = this.block.getElements("close-button");
			this.autoComplete = this.block.getElements("autocomplete-container");
			this.input = this.block.getElements("input");

			this.closeButton.on("click", _.bind(function(e) {
				e.preventDefault();
				this.closeSearch();
			}, this));

			this.button.on("click", _.bind(function(e) {
				if (!this.isMobile) return;

				if (!this.formContainer.bemHasModifier("open")) {
					e.preventDefault();
					this.openSearch();
				}
			}, this));

			enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
				match: _.bind(this.flagDesktop, this),
				unmatch: _.bind(this.flagMobile, this)
			}, true);

			$(window).on('resize', _.debounce(function() {
				var width = self.formContainer.width();
				self.autoComplete.css('width', width);
			}, 400));

		},

		openSearch: function() {
			this.formContainer.bemAddModifier("open");
			this.input.focus();
		},

		closeSearch: function() {
			this.formContainer.bemRemoveModifier("open");
			this.autoComplete.css("display", "none");
		},

		flagDesktop: function() {
			this.isMobile = false;
		},

		flagMobile: function() {
			this.isMobile = true;
		}
	});
});
